import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';

interface StoneXCheckboxProps {
  label: string;
  checked: boolean;
  onUpdate: (checked: boolean) => void;
  helperText?: string;
  error?: string;
  disabled?: boolean;
}

export function StoneXCheckbox(props: StoneXCheckboxProps) {
  return (
    <FormControl error={!!props.error}>
      <FormControlLabel
        control={<Checkbox checked={props.checked} onChange={(event) => props.onUpdate(event.target.checked)} />}
        label={props.label}
        disabled={props.disabled}
      />
      {(props.error || props.helperText) && (
        <FormHelperText sx={{ marginLeft: 0 }}>
          {props.error ?? props.helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
}
